/**
 * TODO:
 * check and remove useless code
 */

import * as React from "react";
import Confetti from 'react-dom-confetti';

import { Deck, Hand, Card, Suit } from "../playing-cards";
import { sortCards, getAllSuits, SUIT_IMAGES } from "../playing-cards/Suit";
import * as storage from "../core/storage";

import { CardComponent } from "./CardComponent";
import { getOpponents, images as opponentImages } from "../engine/Opponent";
import { ScoreboardComponent } from "./ScoreboardComponent";
import { ScoringMelds, Player } from "../engine/Player";
import { RoundData } from "../engine/RoundData";
import { EndRoundComponent } from "./EndRoundComponent";
import { CARD_LOCATIONS } from "../playing-cards/Card";
import { END_GAME_SCORE } from '../engine/Utils';

type Meld = Card[];

export interface IEndGame {
    winner: any;
    endGame: boolean;
}

export interface IBoardState {  
    cards: Meld,
    deck: Deck,
    hands: Hand[],
    players: Player[],
    currentPlayer: number,  // 0-Human, 1-AI
    lastCutCard: number, // control for same cut
    dealer: Player,
    starterCard?: Card,
    isFirstTurn: boolean,
    isDiscardPhase: boolean,
    dealing: boolean,
    currentRound: number,
    gameInfo: string,
    gamePhase: string,
    lockPlayer: boolean, //state just for render
    deckShuffle: boolean,
    scoringIndex: number,
    endGame: IEndGame,
    //scoreboard props
    p1Pin1: number,
    p1Pin2: number,
    p2Pin1: number,
    p2Pin2: number,
    pinClasses: String[],

    //maybe usefull
    endOfRound: boolean, 
    endOfRoundDialog: boolean,    
    drawingCard?: Card,

    //to delete
    discardNeeded?: boolean,
    rounds: RoundData[],
}

const OPPONENT_AI_TIMEOUT = 750;
const NEXT_ACTION_TIMEOUT = 500;
const BALLOON_TIMEOUT = 1000;

const confettiConfig = {
    angle: 90,
    spread: 45,
    startVelocity: 45,
    elementCount: 50,
    decay: 0.9
};

const NUM_PLAYERS = 2;

/**
 * Rules: rules.txt
 * main logics of the game in onDrawSelected, onDiscardCard
 */
export class BoardComponent extends React.Component<any, IBoardState> {
    deck: Deck;

    players: Player[];

    // 2 hands
    hands: Hand[] = [ new Hand(1), new Hand(2)  ];
    rounds: RoundData[];
    currentRound: number;
    suitsPerRound: Suit[] = [];
    maxPlayedCards: number = 4;
    crib: Meld;
    tableCards: Card[];
    tableCounter: number = 0;
    tablePairs: number = 0;
    lockPlayer: boolean = false;
    lastPlayer: number = 3;

    currentDiscardIndex: number = 0;

    constructor (props: any) {
        super(props);
    }

    public componentWillMount() {
        const cachedRounds: any = storage.getItem("rounds");
        if (cachedRounds) {
            this.rounds = JSON.parse(cachedRounds);
            this.players = this.rounds[0].players.map(player => {
                // re-set player team
                player.team = undefined;
                player.isDealer = undefined;
                player.image = opponentImages[player.name];
                player.score = 0;
                player.balloon = false;
                player.balloonText = '';
                player.goBalloon = false;
                player.goBalloonText = '';
                return player;
            });
            this.currentRound = Number(storage.getItem("currentRound") || "0");

        } else {
            // create all players
            this.players = getOpponents(1).map(player => {
                player.score = 0;
                player.balloon = false;
                player.balloonText = '';
                player.goBalloon = false;
                player.goBalloonText = '';
                return player;
            });
            this.players.unshift({ name: "you" } as Player);
            this.rounds = [];
            this.currentRound = 0;
        }
        this.players[0].score = 0;
        this.players[0].balloon = false;
        this.players[0].balloonText = '';
        this.players[0].goBalloon = false;
        this.players[0].goBalloonText = '';
        this.startRound();
    }

    startRound () {
        this.deck = new Deck({
            shuffle: true,
        });
        this.setState({deckShuffle: true});

        setTimeout(() => {
            this.setState({deckShuffle: false});
        }, NEXT_ACTION_TIMEOUT*4);

        this.currentDiscardIndex = 0;
        this.lastPlayer = 3;

        // make sure all hands have no cards.
        this.hands.forEach(hand => hand.clear());
        this.players.forEach((player, i) => {
            player.id = i;
            player.isDealer = (this.state && this.state.dealer && player.id === this.state.dealer.id);
            player.scoringMelds = [];
            player.inGo = 0;
        });

        this.crib = [];
        this.tableCards = [];
        this.tableCounter = 0;
        this.currentDiscardIndex = 0;
        this.tablePairs = 0;

        let currentPlayer = 0,
            gameInfo = '', gamePhase = '';
        if(this.state && this.state.dealer) {
            currentPlayer = (this.state.dealer.id + 1) % NUM_PLAYERS;
        } else {
            gameInfo = 'Cut the deck to define the dealer.';
            gamePhase = 'Before start';
        }

        let isFirstTurn = true;
        if(this.currentRound > 0) {
            isFirstTurn = false;
        }
        if(isFirstTurn) {
            this.setState({
                p1Pin1: 0,
                p1Pin2: 0,
                p2Pin1: 0,
                p2Pin2: 0,
                pinClasses: ['pin-red-start-1', 'pin-red-start-2', 'pin-blue-start-1', 'pin-blue-start-2']
            });
        }

        let boardState = {
            lastCutCard: 0,
            dealing: true,
            isFirstTurn: isFirstTurn,
            isDiscardPhase: false,
            currentPlayer: currentPlayer,
            cards: this.deck.cards,
            hands: this.hands,
            players: this.players,
            rounds: this.rounds,
            currentRound: this.currentRound,
            endOfRoundDialog: false,
            discardNeeded: false,
            drawingCard: undefined,
            starterCard: undefined,
            gameInfo: gameInfo,
            gamePhase: gamePhase,
            lockPlayer: false,
            endGame: {winner: undefined, endGame: false}
        };
        this.setState(boardState, () => {
            // animate card dealing process
            // deal cards only after dealer is defined (after cut)
            if(this.state.dealer) {
                const dealStart = (this.state.currentPlayer + 1) % NUM_PLAYERS;
                setTimeout(()=> {
                    this.dealRound(dealStart, 1, () =>
                        this.dealRound(dealStart, 1, () =>
                            this.dealRound(dealStart, 1, () =>
                                this.dealRound(dealStart, 1, () =>
                                    this.dealRound(dealStart, 1, () =>
                                        this.dealRound(dealStart, 1, () => {

                                            let gameHelper = this.getGameInfo();
                                            gamePhase = gameHelper.gamePhase;
                                            gameInfo = gameHelper.gameInfo;

                                            this.setState({
                                                dealing: false,
                                                gameInfo: gameInfo
                                            }, () => {
                                                if(this.state.dealer.id === 0) {
                                                    this.actAI();
                                                }
                                            })
                                        })
                                    )
                                )
                            )
                        )
                    );
                }, NEXT_ACTION_TIMEOUT);
            }
        });
    }

    playerBalloon = (playerIdx: number, text: string, go: boolean = false) => {
        let players = this.state.players;

        if(go) {
            players[playerIdx].goBalloon =  true;
            players[playerIdx].goBalloonText = text;
        } else {
            players[playerIdx].balloon =  true;
            players[playerIdx].balloonText = text;
        }

        this.players = players;
        this.setState({
            players: players,
        }, () => {
            setTimeout(() => {
                this.removeBalloon(playerIdx, go);
            }, BALLOON_TIMEOUT);
        });
    }

    removeBalloon = (playerNum:number, go: boolean = false) => {
        let players = this.state.players

        if(go) {
            players[playerNum].goBalloon = false;
        } else {
            if(!playerNum) {
                for (let playerNum in players) {
                    players[playerNum].balloon = false;
                }
            } else {
                players[playerNum].balloon = false;
            }
        }
        this.players = players;
        this.setState({
            players: players
        });
    }

    deckShuffle = () => {
        this.deck = new Deck({
            shuffle: true,
        });
        this.setState({cards: this.deck.cards});
    }

    dealCards = (hand: Hand, numCards: number, onComplete?: Function, timeout: number = 80) => {
        this.deck.deal(hand, numCards);

        this.setState({
            cards: this.deck.cards,
            hands: this.hands
        });

        if (onComplete) {
            setTimeout(onComplete, timeout);
        }
    }

    dealRound = (startFrom: number, numCards: number, onComplete?: Function) => {
        let i=0;
        const getHandIndex = () => (startFrom + i) % NUM_PLAYERS;

        this.dealCards(this.hands[getHandIndex()], numCards, () => {
            i++;
            this.dealCards(this.hands[getHandIndex()], numCards, onComplete);
        });
    }

    onDiscardCard = (card: Card) => {
        const cardIndex = this.hands[this.state.currentPlayer].cards.indexOf(card);
        //if tried to discard a hand card, setting crib pile
        if(cardIndex !== -1 && this.state.currentPlayer !== this.lastPlayer) {
            //need player code to positioning in table
            let keepPlayerInCard = this.crib.length === 4;

            if(this.crib.length !== 4) {
                const discardedCard = this.hands[this.state.currentPlayer].discard(cardIndex, this.currentDiscardIndex++, keepPlayerInCard);

                discardedCard.location = CARD_LOCATIONS.IN_CRIB;
                this.crib.push(discardedCard);

                let nextState = {
                    hands: this.state.hands,
                    players: this.players,
                    cards: this.deck.cards,
                };
                this.setState(nextState, () => {
                    //if player discarded 2, AI act
                    if(this.crib.length === 2 || this.crib.length === 4) {
                        this.nextTurn(true, {}, false)
                    }
                });

            //actual game
            } else {
                if(this.state.currentPlayer === 1 || (this.state.currentPlayer === 0 && !this.lockPlayer)) {
                    this.lastPlayer = this.state.currentPlayer
                    this.lockPlayer = true
                    const discardedCard = this.hands[this.state.currentPlayer].discard(cardIndex, this.currentDiscardIndex++, keepPlayerInCard);
                    this.tableCounter += discardedCard.value || 0;
                    discardedCard.discardIndex = this.currentDiscardIndex;
                    discardedCard.location = CARD_LOCATIONS.IN_TABLE;
                    this.tableCards.push(discardedCard);

                    this.setState({
                        cards: this.deck.cards,
                        lockPlayer: this.lockPlayer,
                    }, () => {
                        this.nextTurn();
                    });
                }

            }
        }
    }

    nextTurn (changeCurrentPlayer: boolean = true, nextState: IBoardState & any = {}, timeout: boolean = true) {
        nextState.players = this.state.players;

        nextState.currentPlayer = (changeCurrentPlayer)
            ? (this.state.currentPlayer + 1) % NUM_PLAYERS
            : this.state.currentPlayer;

        let gameHelper = this.getGameInfo(nextState.currentPlayer);
        nextState.gamePhase = gameHelper.gamePhase;
        nextState.gameInfo = gameHelper.gameInfo;

        if (nextState.isFirstTurn && this.state.dealer !== undefined) {
            setTimeout(() => {
                this.setState(this.getStarterCard(nextState))
            }, NEXT_ACTION_TIMEOUT);
        } else {

            if(this.state.starterCard && this.crib.length === 4) {
                //show ballon and check scores only if not in go
                let nextPlayer = (this.state.currentPlayer + 1) % NUM_PLAYERS;
                //score only in play, avoid scoring in "auto phase" at "go"
                if(this.players[this.state.currentPlayer].inGo === 0  && this.players[nextPlayer].inGo !== 1  && this.players[nextPlayer].inGo !== 2) {
                    this.computeScores(this.state.currentPlayer);
                }
            }

            const passTurn = () => {
                //check for the go only in play
                if(this.state.starterCard && this.crib.length === 4) {
                    this.checkGo();
                }

                let nextPlayer = (this.state.currentPlayer + 1) % NUM_PLAYERS;
                //AI action
                if (this.state.currentPlayer !== 0 && this.canPlay(this.state.currentPlayer)) {
                    this.actAI();
                } else if(this.state.players[0].inGo === 0 && this.players[nextPlayer].inGo !== 1 && this.players[nextPlayer].inGo !== 2) {
                    //unlock player if he is not in Go and is not just a message turn
                    setTimeout(() => {
                        this.lockPlayer = false;
                        this.setState({lockPlayer: this.lockPlayer});
                    }, NEXT_ACTION_TIMEOUT);
                }
            }

            if(timeout) {
                setTimeout(() => {
                    this.setState(nextState, () => {
                        passTurn();
                    });
                }, NEXT_ACTION_TIMEOUT);
            } else {
                this.setState(nextState, () => {
                    passTurn();
                });
            }
        }
    }

    //currentPlayer / nextPlayer are reversed here, because it have to be excecuted after nextTurn state set
    checkGo() {
        let go = 1,
            currentPlayer = this.state.currentPlayer,
            nextPlayer = (currentPlayer + 1) % NUM_PLAYERS;

        if(this.players[nextPlayer].inGo === 1) {
            this.players[nextPlayer].inGo++;
            this.setState({players: this.players}, () => {
                this.lastPlayer = 3;
                this.playerBalloon(currentPlayer, "1 for the Go", true);
                this.inPlayScore(currentPlayer, 1);
            });
        }

        if(this.state.hands[currentPlayer].cards.length === 0 && this.state.hands[nextPlayer].cards.length === 0) {
            setTimeout(() => {
                this.setState({endOfRoundDialog: true});
            }, NEXT_ACTION_TIMEOUT);
            return;
        }

        if(this.tableCounter === 31) {
            setTimeout(() => {
                this.resetTable();
            }, NEXT_ACTION_TIMEOUT);
            return;
        }

        if(this.canPlay(currentPlayer)) {
            go = 0;
        } else {
            if(this.players[currentPlayer].inGo === 0) {
                //if opponent on go 1st
                if(this.players[nextPlayer].inGo > 0) {
                    this.resetTable();
                } else {
                    this.onGo();
                }
            //if player inGo and opponent can't play anymore
            } else if (!this.canPlay(nextPlayer)) {
                this.resetTable();
            //player yet in go and opponent can play
            } else {
                this.lastPlayer = this.state.currentPlayer;
                this.nextTurn();
            }
        }

        return go;
    }

    onGo() {
        this.playerBalloon(this.state.currentPlayer, "Go! 👎", true);
        this.players[this.state.currentPlayer].inGo++;

        setTimeout(() => {
            this.setState({
                players: this.players
            }, () => {
                this.nextTurn();
            });
        }, NEXT_ACTION_TIMEOUT);
    }

    canPlay(currentPlayer:number) {
        //if can play cards with ooponent in GO. (The "Go" caller starts the new round)
        let canPlay = true,
            cards = this.hands[currentPlayer].cards;

        //if in play phase
        if(this.state.starterCard && this.crib.length === 4) {
            canPlay = false;

            if(cards.length === 0) {
                return false;
            }

            for (let i = 0; i <= cards.length-1; i++) {
                let cardValue = cards[i].value || 0;
                if (cardValue + this.tableCounter <= 31) {
                    canPlay = true
                }
            }
        }
        return canPlay;
    }

    resetTable(passTurn: boolean = false) {
        let currentPlayer = this.state.currentPlayer,
            nextPlayer = (currentPlayer + 1) % NUM_PLAYERS,
            players = this.state.players,
            inGoPlays = currentPlayer;

        if(players[currentPlayer].inGo > 0) {
            inGoPlays = currentPlayer;
        }

        if(players[nextPlayer].inGo > 0) {
            inGoPlays = nextPlayer;
        }

        players[currentPlayer].inGo = 0;
        players[nextPlayer].inGo = 0;
        this.tableCounter = 0;

        //add a blur effect in already scored table cards
        let intersection = this.state.cards.filter(card => this.tableCards.includes(card));
        intersection.forEach(card => card.used = true)
        this.tableCards = [];

        this.tablePairs = 0;
        this.players = players;
        this.setState({
            players: players,
            currentPlayer: inGoPlays
        }, () => {
            if(passTurn) {
                this.nextTurn(true, {}, false);
            }
            if(inGoPlays === 1) {
                setTimeout(() => {
                    this.actAI();
                }, OPPONENT_AI_TIMEOUT);
            } else {
                setTimeout(() => {
                    this.lockPlayer = false;
                    this.setState({lockPlayer: this.lockPlayer});
                }, NEXT_ACTION_TIMEOUT);
            }
        });
    }

    resetPlay = () => {
        //a time out to display the messages and not restart abruptly
        setTimeout(() => {
            let players = this.state.players;

            players[this.state.dealer.id].isDealer = false;
            players[(this.state.dealer.id + 1) % NUM_PLAYERS].isDealer = true;
            let dealer = players[(this.state.dealer.id + 1) % NUM_PLAYERS];

            this.players = players;
            this.setState({
                players: players,
                dealer: dealer,
                endOfRoundDialog: false,
                currentRound: this.currentRound++
            }, this.startRound);
        }, NEXT_ACTION_TIMEOUT);
    }

    setScoringIndex = (scoringIndex:number) => {
        this.setState({scoringIndex: scoringIndex});
    }

    onDrawSelected (card: Card, callback?: any, nextState: any = {}) {
        let checkCardAllowed = (card: Card) => {
            let cardValue = card.value || 0;
            return cardValue + this.tableCounter <= 31
        };

        //avoid spam click messing with balloon messages
        if(this.state.currentPlayer === 0 && this.state.lockPlayer || !this.canPlay(this.state.currentPlayer)) {
            return
        }

        if(this.state.deckShuffle === false) {
            if(!this.state.starterCard && card.location === CARD_LOCATIONS.IN_DECK) {
                //cut deck for start
                nextState.isFirstTurn = this.state.isFirstTurn;
                if (nextState.isFirstTurn && this.state.dealer === undefined) {
                    card.location = this.state.currentPlayer;
                    this.hands[this.state.currentPlayer].draw(card);

                    //set the starting dealer. (at cut, check numbers not values)
                    if(this.state.lastCutCard === 0) {
                        nextState.lastCutCard = card.number;
                    } else {
                        //if AI cuts higher, human is the dealer
                        let players = this.state.players;
                        if(card.number !== undefined && card.number > this.state.lastCutCard) {
                            nextState.dealer = this.state.players[0]
                            players[0].isDealer = true;
                            players[1].isDealer = false;
                        } else {
                            //if same value cut, cut again
                            if(card.number === this.state.lastCutCard) {
                                this.state.players.forEach((player, i) => {
                                    this.playerBalloon(i, "Same value! Let's cut again...");
                                });
                                nextState.lastCutCard = 0;
                                this.setState(nextState, () => {
                                    this.nextTurn(true, nextState, false)
                                });
                                return
                            //AI is the dealer
                            } else {
                                nextState.dealer = this.state.players[1]
                                players[1].isDealer = true;
                                players[0].isDealer = false;
                            }
                        }
                        this.players = players;
                        nextState.players = players;

                        this.playerBalloon(nextState.dealer.id, "I'm the dealer");

                        nextState.cards = this.deck.cards;
                        nextState.drawingCard = card;

                        setTimeout(() => {
                            this.handToDeck(nextState);
                        }, NEXT_ACTION_TIMEOUT);

                        return
                    }
                    nextState.cards = this.deck.cards;
                    nextState.drawingCard = card;

                    this.setState(nextState, () => {
                        if (callback instanceof Function) {
                            callback();
                        }
                        this.nextTurn(true, nextState, false);
                    });
                // cut for the starterCard
                } else if(this.crib.length === 4) {
                    if(card.number === 11) {
                        this.playerBalloon(this.state.dealer.id, "His Heels, 2");
                        this.inPlayScore(this.state.dealer.id,2);
                    }
                    //keep the 4 cards hand to compute score at end of round
                    this.players[0].hand = new Hand(1);
                    this.players[1].hand = new Hand(2);
                    this.players[0].hand.cards = [...this.state.hands[0].cards]
                    this.players[1].hand.cards = [...this.state.hands[1].cards]
                    this.setState({starterCard: card}, () => {
                        let gameHelper = this.getGameInfo();
                        this.setState({
                            players: this.players,
                            gamePhase: gameHelper.gamePhase,
                            gameInfo: gameHelper.gameInfo
                        }, () => {
                            if (callback instanceof Function) {
                                callback();
                            }
                        });
                    });
                }

            //discard to set the crib, or for the game
            } else if (((this.crib.length < 4 && !this.state.starterCard)
            || this.crib.length === 4 && this.state.starterCard) && this.state.dealer !== undefined) {
                if(checkCardAllowed(card)) {
                    this.onDiscardCard(card);
                } else {
                    this.playerBalloon(this.state.currentPlayer, "Oh, I can't exceed 31.");
                }
            }
        }
    }

    handToDeck = (nextState: any) => {
        this.hands.forEach((hand) => {
            hand.cards.forEach(card => {
                card.location = CARD_LOCATIONS.IN_DECK;
                card.player = undefined;
            });
        });

        setTimeout(() => {
            this.startRound();
        }, NEXT_ACTION_TIMEOUT);

        this.setState(nextState, () => {
            this.nextTurn(true, nextState, false);
        });
    }

    dialogClick = (e: React.MouseEvent) => {
        e.preventDefault();
    }

    getGameInfo(currentPlayer:number = this.state.currentPlayer) {
        let gameHelper = {
            gamePhase: this.state.gamePhase,
            gameInfo: this.state.gameInfo
        };

        if(this.state.dealer !== undefined) {
            if(!this.state.starterCard) {
                if(this.crib.length < 4) {
                    gameHelper.gamePhase = 'Setting crib';
                    gameHelper.gameInfo = 'Discard 2 cards for the crib.';
                    if(currentPlayer === 1) {
                        gameHelper.gameInfo = 'Discarding 2 for the crib.';
                    }
                } else {
                    //startercard, phase removed, auto now.
                    gameHelper.gamePhase = '';
                    gameHelper.gameInfo = '';
                }
            } else {
                gameHelper.gamePhase = 'The Play';
                gameHelper.gameInfo = 'Discard a card.';
                if(currentPlayer === 1) {
                    gameHelper.gameInfo = 'Discarding a card.';
                }
            }
        } else {
            gameHelper.gameInfo = 'Cutting the deck to define the dealer.';
            gameHelper.gamePhase = 'Before start';
        }

        return gameHelper;
    }

    //compute runs in hand and table, checkIndex is needed for in table runs only
    computeRuns = (cards: Card[], checkIndex: boolean = false, aiCard?:Card) => {
        let runsPartial: Meld[] = [],
            computingRuns: Card[] = [],
            run: Card[][] = [],
            counter = 0,
            uniqueCards = [...cards],
            repeatedCardsInRun: Card[] = [];

        if(aiCard) {
            aiCard.discardIndex = this.tableCards.length;
            cards.push(aiCard);
        }

        //split the repeated cards for easier run checks
        uniqueCards = uniqueCards.reduce<Card[]>((runs, card1:Card) => {
            let concatResult;
            if(runs.find((card2) => card2.number === card1.number)) {
                repeatedCardsInRun.push(card1);
                concatResult = [];
            } else {
                concatResult = card1;
            }
            return runs.concat(concatResult);
        }, []);

        const checkRuns = (cards: Card[]) => {
            cards = sortCards(cards, {
                asc: true,
                ignoreSuits: true,
                suits: getAllSuits()
            });

            if(counter < cards.length) {
                if(cards[counter+1] !== undefined)  {
                    if(Math.abs((cards[counter].number || 0) - (cards[counter+1].number || 0)) === 1) {
                        if(computingRuns.find((card) => card.id === cards[counter].id) === undefined) {
                            computingRuns.push(cards[counter]);
                        }
                        if(computingRuns.find((card) => card.id === cards[counter+1].id) === undefined) {
                            computingRuns.push(cards[counter+1]);
                        }
                    } else {
                        if(computingRuns.length >= 3) {
                            run.push(computingRuns);
                        }
                        computingRuns = [];
                    }
                } else {
                    if(computingRuns.length >= 3) {
                        run.push(computingRuns);
                    }
                }

                counter++;
                checkRuns(cards);
            }

            return run;
        };

        runsPartial = checkRuns(uniqueCards);

        //add new runs for the repeated cards
        const setAllRuns = (runs: Meld[]) => {
            //create a new run for each repeated card
            repeatedCardsInRun.forEach((card: Card, reIdx) => {
                runs.forEach((run: Card[], idx) => {
                    run.find((rcard,i) => {
                        if(rcard.number === card.number && rcard.suit !== card.suit) {
                            let newRun = [...runsPartial[idx]]
                            newRun[i] = card;
                            runsPartial.push(newRun);
                            repeatedCardsInRun = repeatedCardsInRun.filter((cpy,i) => {
                                return cpy.id !== card.id
                            });
                        }
                        return rcard.number === card.number && rcard.suit !== card.suit
                    });
                });
            });

            //keep only repeated cards that are in some run
            repeatedCardsInRun = repeatedCardsInRun.filter((card, i) => {
                let cardFound = false
                runs.forEach((rcard: Card[]) => {
                    cardFound = rcard.some((c) => c.value === card.value)
                });
                return cardFound;
            });

            //check again in case of runs and pairs, to compute all that's possible
            if(repeatedCardsInRun.length > 0) {
                setAllRuns(runsPartial);
            }
        }

        //TODO: pay attention here, sometimes this broke the page on infinite loop. maybe related to spam click, not sure
        try {
            setAllRuns(runsPartial);
        } catch (error) {
            alert('bug happened');
            console.log('ERROR:',error);
            console.log('current table:',this.tableCards);
            console.log('state',this.state);
        }

        if(checkIndex) {
            //validate the table run was not broke by out of run card
            let maxIndex = 0;
            const validateRuns = (cards: Card[]) => {
                if(cards && cards.length > 2) {
                    cards.sort( (a,b) => {
                        return (a.discardIndex || 0) as number - (b.discardIndex || 0) as number
                    });

                    if(counter < cards.length) {
                        if(cards[counter+1] !== undefined)  {
                            if(Math.abs((cards[counter].discardIndex || 0) - (cards[counter+1].discardIndex || 0)) === 1) {
                                if(computingRuns.find((card) => card.id === cards[counter].id) === undefined) {
                                    computingRuns.push(cards[counter]);
                                }
                                if(computingRuns.find((card) => card.id === cards[counter+1].id) === undefined) {
                                    computingRuns.push(cards[counter+1]);
                                }
                                maxIndex = cards[counter+1].discardIndex || 0;
                            } else {
                                if(computingRuns.length >= 3) {
                                    run.push(computingRuns);
                                }
                                computingRuns = [];
                            }
                        } else {
                            if(computingRuns.length >= 3) {
                                run.push(computingRuns);
                            }
                        }

                        counter++;
                        validateRuns(cards);
                    }

                    //run must be part of the last card discarded
                    if(maxIndex === this.tableCards.length) {
                        return run;
                    } else return [];
                } else return [];
            };

            let nonBrokenRun: Card[][] = []
            runsPartial.forEach((runp: Card[]) => {
                computingRuns = [];
                run = [];
                counter = 0;
                nonBrokenRun = validateRuns(runp);
            });
            return nonBrokenRun;
        } else {
            return runsPartial;
        }
    }

    computeScores = (currentPlayer: number) => {
        const cards = this.tableCards,
              nextPlayer = (currentPlayer + 1) % NUM_PLAYERS;

        let balloonText = this.tableCounter.toString(),
            score = 0;

        if(cards.length > 1) {

            if(this.state.hands[currentPlayer].cards.length === 0 && this.state.hands[nextPlayer].cards.length === 0) {
                balloonText += ", 1 for the last";
                score += 1;
            }

            if(this.tableCounter === 31) {
                balloonText += ", 2 for the 31";
                score += 2;
            }

            if(this.tableCounter === 15) {
                balloonText += ", 2 for the 15";
                score += 2;
            }

            if(cards[cards.length-2].number === cards[cards.length-1].number) {
                this.tablePairs++;
                switch(this.tablePairs) {
                    case 1:
                        balloonText += ", 2 for the pair";
                        score += 2;
                    break;
                    case 2:
                        balloonText += ", 6 for the triplet";
                        score += 6;
                    break;
                    case 3:
                        balloonText += ", 12 for the double pair";
                        score += 12;
                    break;
                }
            } else this.tablePairs = 0;

            let nonBrokenRun = this.computeRuns([...cards], true);

            if(nonBrokenRun[0] && nonBrokenRun[0].length >= 3) {
                balloonText += ", " + nonBrokenRun[0].length + ' for the run';
                score += nonBrokenRun[0].length;

                this.playerBalloon(currentPlayer, balloonText);
                this.inPlayScore(currentPlayer, score);
                //return for unit test only
                return nonBrokenRun[0].length
            }

            this.playerBalloon(currentPlayer, balloonText);
            this.inPlayScore(currentPlayer, score);

            return 0
        }

        if(this.tableCounter > 0) {
            this.playerBalloon(currentPlayer, balloonText);
            this.inPlayScore(currentPlayer, score);
        }
        //return for unit test only
        return 0
    }

    inPlayScore = (currentPlayer: number, score:number) => {
        let players = this.state.players,
            endofround = false,
            endGame: IEndGame;
        players[currentPlayer].score += score;
        endGame = {
            winner: undefined,
            endGame: false
        }
        if(this.state.endOfRoundDialog) {
            endofround = true;
        }
        if(players[currentPlayer].score >= END_GAME_SCORE) {
            endofround = true;
            endGame = {
                winner: players[currentPlayer],
                endGame: true
            }
        }
        this.setState({
            players: players,
            endOfRoundDialog: endofround,
            endGame: endGame,
        }, () => {
            let pinClasses = this.state.pinClasses,
                score = this.state.players[currentPlayer].score;

            if(score > END_GAME_SCORE) {
                score = END_GAME_SCORE;
            }
            if(currentPlayer === 0 && score > 0) {
                if(this.state.p1Pin1 > this.state.p1Pin2 && score > this.state.p1Pin1) {
                    pinClasses[1] = 'pin-red-'+score;
                    this.setState({p1Pin2: score});
                } else if(score > this.state.p1Pin2) {
                    pinClasses[0] = 'pin-red-'+score;
                    this.setState({p1Pin1: score});
                }
                this.setState({
                    pinClasses: pinClasses,
                });
            } else if(currentPlayer === 1 && score > 0) {
                if(this.state.p2Pin1 > this.state.p2Pin2  && score > this.state.p2Pin1) {
                    pinClasses[3] = 'pin-blue-'+score;
                    this.setState({p2Pin2: score});
                } else if(score > this.state.p2Pin2) {
                    pinClasses[2] = 'pin-blue-'+score;
                    this.setState({p2Pin1: score});
                }
                this.setState({
                    pinClasses: pinClasses,
                });
            }
        });
    }

    getStarterCard (nextState: IBoardState & any) {
        nextState.isFirstTurn = false;
        nextState.isDiscardPhase = true;
        this.hands.forEach(hand => hand.clear());
        nextState.hands = this.hands;

        this.deck = new Deck({
            shuffle: true,
        });
        nextState.cards = this.deck.cards;

        //dealer plays last
        if (nextState.dealer && nextState.dealer.id === nextState.players[nextState.currentPlayer].id) {
            nextState.currentPlayer = (nextState.currentPlayer + 1) % NUM_PLAYERS;
        }

        return nextState;
    }

    actAI = () => {
        //TODO
        console.log("ACT AI!");

        //when in play, check the better card for discard
        const getBetterDiscard = () => {
            //can check the highest score also, for better AI.
            let aiCards = this.hands[1].cards,
                possibleRun = [],
                returnIndex = -1;

            aiCards.forEach((card,i) => {
                if(card.value !== undefined) {
                    //1st check for scorable card
                    if(this.tableCounter + card.value === 15 || this.tableCounter + card.value === 31) {
                        returnIndex = i;
                    }

                    //if already have cards in table and checking card can be played
                    if(this.tableCards.length > 0 && (card.value || 0) + this.tableCounter <= 31) {
                        //check for pairs
                        if(this.tableCards[this.tableCards.length-1].number || 0 === card.number) {
                            returnIndex = i;
                        }

                        //check for runs
                        possibleRun = this.computeRuns([...this.tableCards], true, card);
                        if(possibleRun.length >= 3) {
                            returnIndex = i;
                        }
                    }
                }
            });
            if(returnIndex !== -1) {
                return returnIndex
            }

            const getWithRandomIndex = () => {
                //discard anything that can
                let randomIndex = Math.floor(Math.random() * aiCards.length),
                    cardValue = aiCards[randomIndex].value || 0;
                if(cardValue + this.tableCounter <= 31) {
                    return randomIndex;
                } else {
                    return -1;
                }
            }

            let returnRandomIdx = getWithRandomIndex();
            while(returnRandomIdx === -1) {
                returnRandomIdx = getWithRandomIndex();
            }
            return returnRandomIdx;

        }

        setTimeout(()=> {
            if (this.state.currentPlayer === 1 && !this.state.endOfRoundDialog && !this.state.endGame.endGame) {
                //cut for the dealer
                if ((this.state.starterCard === undefined && this.crib.length === 4)
                || this.state.isFirstTurn) {
                    //1st play cut for the dealer, 2nd play cut for the starter card
                    this.onDrawSelected(this.deck.draw(), () => {
                        //if player is dealer, AI start playing
                        if(!this.state.isFirstTurn && this.state.dealer.id === 0 && this.tableCards.length === 0) {
                            setTimeout(() => {
                                this.actAI();
                            }, NEXT_ACTION_TIMEOUT);
                        }
                    });
                    this.currentDiscardIndex = 0;
                } else {
                    if(this.hands[this.state.currentPlayer].cards.length > 0) {
                        //if AI discarded +2 and is not dealer
                        if(this.crib.length === 4 && !this.state.starterCard) {
                            this.nextTurn();

                        //discard 2 for crib
                        } else if(this.crib.length < 4) {
                            this.onDrawSelected(this.hands[1].cards[Math.floor(Math.random() * this.hands[1].cards.length)],
                                setTimeout(() => {
                                    this.actAI();
                                }, NEXT_ACTION_TIMEOUT)
                            );

                            //AI discarded 2 and is the dealer. (auto cut the starter card)
                            if(this.crib.length === 4 && !this.state.starterCard) {
                                setTimeout(() => {
                                    this.onDrawSelected(this.deck.draw());
                                    //for css table cards
                                    this.currentDiscardIndex = 0;
                                }, NEXT_ACTION_TIMEOUT);
                            }
                        //the game
                        } else {
                            this.onDrawSelected(this.hands[1].cards[getBetterDiscard()]);
                        }
                    } else {
                        this.nextTurn();
                    }
                }
            }
        }, OPPONENT_AI_TIMEOUT);
    }

    getPreviousPlayer () {
        return (4 + (this.state.currentPlayer - 1)) % 4;
    }

    computeEndOfRound = (hand: any, crib: boolean = false) => {
        let sets: Meld[] = [],
            setsByNumber: {[number: number]: Meld} = {},
            setsBySuit: Meld[] = [],
            setsByFifteen: any = [],
            scoringMelds: ScoringMelds[] = [],
            starterSuit = (this.state.starterCard) ? this.state.starterCard.suit : '';

        const cardsNoStarter = sortCards(hand.cards, {
            asc: true,
            ignoreSuits: true,
            suits: getAllSuits()
        });

        const cards = sortCards(hand.cards.concat(this.state.starterCard), {
            asc: true,
            ignoreSuits: true,
            suits: getAllSuits()
        });

        const suitIndex = ['H','D','C','S']

        function checkFifteen(cards: any, tempFifteen: any) {
            let sum = 0;
            tempFifteen.forEach((card: any) => {
                sum = sum + card.value;
            });
            if (sum == 15) {
                setsByFifteen.push(tempFifteen);
                scoringMelds.push({cards: tempFifteen, name: 'Fifteen', score: 2});
            }
            if (sum > 15) {
                return;
            }
            for (var i=0; i<cards.length; i++) {
                let card = cards[i],
                    remaining = cards.slice(i+1),
                    partical_arr = tempFifteen.slice();
                partical_arr.push(card);
                checkFifteen(remaining, partical_arr);
            }
        }

        // Retrieve all SETS
        cards.forEach((card) => {
            const number = card.number as number;
            if (!setsByNumber[number]) {
                setsByNumber[number] = [];
            }
            setsByNumber[number].push(card);
        });

        cardsNoStarter.forEach((card) => {
            const suitSetIdx = suitIndex.indexOf(card.suit)
            if(!setsBySuit[suitSetIdx]) {
                setsBySuit[suitSetIdx] = []
            }
            setsBySuit[suitSetIdx].push(card);

            if(starterSuit === card.suit && card.number === 11) {
                sets.push([card]);
                scoringMelds.push({cards: [card], name: 'His Nobs', score: 1})
            }
        });

        checkFifteen(cards,[]);

        for (let number in setsByNumber) {
            if (setsByNumber[number].length >= 2) {
                switch (setsByNumber[number].length) {
                    case 2: scoringMelds.push({cards: setsByNumber[number], name: 'Pair', score: 2}); break;
                    case 3: scoringMelds.push({cards: setsByNumber[number], name: 'Triplet', score: 6}); break;
                    case 4: scoringMelds.push({cards: setsByNumber[number], name: 'Double pair', score: 12}); break;
                }
                sets.push(setsByNumber[number]);
            }
        }

        //length = 1 = flush, 4 cards of same suit in hand
        if(setsBySuit.length === 1) {
            if(starterSuit === setsBySuit[0][0].suit) {
                sets.push(setsBySuit[0]);
                scoringMelds.push({cards: setsBySuit[0], name: 'Four-flush', score: 5});
            } else if(!crib) {
                sets.push(setsBySuit[0]);
                scoringMelds.push({cards: setsBySuit[0], name: 'Flush', score: 4});
            }
        }

        setsByFifteen.forEach((fifteen: any) => sets.push(fifteen));

        let runs = this.computeRuns([...cards])
        //set the melds to display
        runs.forEach((run: Card[], idx) => {
            scoringMelds.push({cards: run, name:'Run', score: run.length});
        });

        return scoringMelds;
    }

    getCardShortName (card: Card, i?: number) {
        let name: string;

        switch (card.number) {
            case 1: name = "A"; break;
            case 11: name = "J"; break;
            case 12: name = "Q"; break;
            case 13: name = "K"; break;
            default: name = (card.number as number).toString();
        }

        return <span key={i} className={`short-card suit-${card.suit}`}>
            <img src={SUIT_IMAGES[card.suit]} /> {name}
        </span>
    }

    public render () {
        const isCurrentPlayer = this.state.currentPlayer === 0;

        const hasOverlay = !isCurrentPlayer;

        let playerCardIdx = 0,
            aiCardIdx = 0,
            endOfRoundp1 = 0,
            endOfRoundp2 = 0;

        return <section className={`board`}>
            <div className="confetti">
                <Confetti active={(this.state.endGame.endGame)} config={ confettiConfig }/>
            </div>

            {
            //<div className="banner-left">&nbsp;</div>
            //<div className="banner-bottom">&nbsp;</div>
            }

            <ScoreboardComponent
                players={this.state.players}
                rounds={this.state.rounds}
                currentPlayer={this.state.currentPlayer}
                pinClasses={this.state.pinClasses} />

            {(this.state.endOfRoundDialog)
                ? <EndRoundComponent
                    onResetPlay={this.resetPlay}
                    onRestartGame={this.startRound}
                    currentRound={this.state.currentRound}
                    getCardShortName={this.getCardShortName}
                    players={this.state.players}
                    computeMelds={this.computeEndOfRound}
                    crib={this.computeEndOfRound({cards: this.crib}, true)}
                    computeScore={this.inPlayScore}
                    scoringIndex={0}
                    setScoringIndex={this.setScoringIndex}
                    endGame={this.state.endGame} />
                : null}

            <div className="table-counter" style={{visibility: this.state.starterCard && this.state.dealer ? 'visible' : 'hidden' }}>
                {this.tableCounter}
            </div>

            {this.state.players.map((opponent, i) => (
                <div
                    key={`player-${i}`}
                    className={`
                        player
                        i-${i+1}
                        ${(opponent.isDealer) ? 'dealer' : ''}
                        ${(this.state.currentPlayer == i) ? 'current' : ''}
                    `}>
                    { (opponent.image)
                        ? <img src={opponent.image} />
                        : null }
                    <span className={`balloon ${opponent.balloon ? "active" : ""}`}>{opponent.balloonText}</span>
                    <span className={`balloon ${opponent.goBalloon ? "active" : ""}`}>{opponent.goBalloonText}</span>

                    <span className="name">
                        {opponent.name}
                        <span className={`team ${opponent.team}`}>{opponent.team}</span>
                        <span className="dealer">D</span>
                    </span>
                </div>
            ))}

            <div className={`dialog-overlay ${hasOverlay ? "" : "inactive"}`} onClick={this.dialogClick}>
                <div className="dialog">
                    &nbsp;
                </div>
            </div>

            <div className={"gameinfo-p"+this.state.currentPlayer}>
                { this.state.gameInfo }
            </div>

            {/* All cards */}
            {this.state.cards.map((card, i) => {
                //TODO: check state.drawingCard probably not needed
                const playerNum = (!isCurrentPlayer || card !== this.state.drawingCard || this.state.isFirstTurn)
                    ? card.player as number
                    : undefined;
                const player = playerNum !== undefined ? this.players[playerNum - 1] : undefined;

                const faceUp = (
                    (playerNum === 1) ||
                    (card.location === CARD_LOCATIONS.IN_TABLE) ||
                    (card.player !== undefined && this.state.isFirstTurn) ||
                    (this.state.starterCard !== undefined && card.id === this.state.starterCard.id)
                );
                const enabled = (
                    !this.state.endOfRound && ! this.state.endOfRoundDialog &&
                    player !== undefined &&
                    !player.played && (
                        this.state.discardNeeded || this.state.currentPlayer === 0
                    )
                    && this.state.lockPlayer === false
                );
                const cardScored = (
                    card.location === CARD_LOCATIONS.IN_TABLE && card.used
                )

                // on-click handler
                let onClick = this.onDrawSelected.bind(this, card, undefined, undefined);

                // class name
                let className = (playerNum && `player-${playerNum}`) || ('board ' + (this.state.dealing ? 'dealing' : ''));

                if (card.location === CARD_LOCATIONS.IN_CRIB || card.location === CARD_LOCATIONS.IN_TABLE) {
                    className = " ";
                }

                if(this.state.deckShuffle) {
                    className += " shuffle";
                }

                if (this.state.endOfRoundDialog && !this.state.endGame.endGame) {
                    className += " end-of-round";
                    card.used = false;
                    if(card.player === 1 && this.state.scoringIndex === 0) {
                        i = endOfRoundp1;
                        endOfRoundp1++;
                        className += " player1-"+i;
                    } else if(card.player === 2 && this.state.scoringIndex === 1) {
                        i = endOfRoundp2;
                        endOfRoundp2++;
                        className += " player2-"+i;
                    }
                }

                if (this.state.isFirstTurn && !this.state.deckShuffle) {
                    className += " drawing enabled";
                }

                if (this.state.dealer && card.location === CARD_LOCATIONS.IN_CRIB) {
                    className += " dealer-p" + this.state.dealer.id;
                    className += " player-" + (this.state.dealer.id + 1);
                    className += " crib-" + card.discardIndex;
                    if(this.state.endOfRoundDialog && this.state.scoringIndex === 2) {
                        className += " player-crib-" + card.discardIndex;
                    }
                }

                if (this.state.starterCard) {
                    className += " deck-cutted";
                }

                if (card.location === CARD_LOCATIONS.IN_TABLE) {
                    //player in card is 1 or 2
                    let cardPlayer = card.player || 0;
                    let cardIndex = card.discardIndex || 0;
                    if(!this.state.endOfRoundDialog) {
                        //no class conflicts here
                        i = 999;
                        className += " dealer-p" + this.state.dealer.id;
                        className += " game-table p-"+(cardPlayer-1);
                    }
                    className += " i-"+(cardIndex+1);
                }

                if(card.location === CARD_LOCATIONS.IN_AI) {
                    i = aiCardIdx;
                    aiCardIdx += 2;
                }

                if(card.location === CARD_LOCATIONS.IN_PLAYER1) {
                    i = playerCardIdx;
                    playerCardIdx += 2;
                }

                if(card === this.state.starterCard) {
                    className += " starter-card";
                }

                // prevent i from being less than zero
                if (i < 0) i = 5;

                return <CardComponent
                    player={playerNum}
                    key={`card-${card.suit}${card.number}`}
                    className={className}
                    faceUp={faceUp}
                    used={cardScored}
                    onClick={onClick}
                    enabled={enabled}
                    i={i}
                    {...card} />
            })}

        </section>;
    }

}



// WEBPACK FOOTER //
// ./src/components/BoardComponent.tsx